import { forwardRef, Ref, type SVGProps } from 'react';

const SvgInfoCircleIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <circle cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={1.5} />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 11v5"
    />
    <circle cx={12} cy={8} r={0.75} fill="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgInfoCircleIcon);
export default ForwardRef;
